/**
 * @create by SNOW 2019.04.19
 */
import Vue from 'vue'
import confirmDialogVue from './confirmDialog.vue'

const ConfirmDialogConstructor = Vue.extend(confirmDialogVue)

let instance
let currentMsg = {}

const initInstance = (resolve, reject) => {
  instance = new ConfirmDialogConstructor({
    el: document.createElement('div')
  })
  instance.callback = (action) => {
    if (action === 'cancel') {
      currentMsg.reject(action)
    }
    if (action === 'confirm') {
      currentMsg.resolve(action)
    }
    Vue.nextTick(() => {
      instance.visible = false
    })
  }
}

const showMsg = () => {
  if (!instance) {
    initInstance()
  }
  instance.message = currentMsg.message
  instance.title = currentMsg.title
  if (!instance.visible) {
    document.body.appendChild(instance.$el) // potential performance optimization
    Vue.nextTick(() => {
      instance.visible = true
      // el-dialog每次弹出z-index自增2，如果confirmDialog的z-index固定，总会被el-dialog遮盖
      // 每次读取页面最大z-index，自增2赋值给confirmDialog；或者使用el-dialog
      // let maxIndex = Array.from(document.querySelectorAll('body *'))
      // .map(a => parseInt(document.defaultView.getComputedStyle(a, null).getPropertyValue('z-index')))
      // .filter(a => !isNaN(a))
      // .sort((a, b) => a - b)
      // .pop();
      // let maxIndex = Math.max.apply(null, Array.prototype.map.call(document.querySelectorAll('body *'), function(el) {
      //   return parseInt(document.defaultView.getComputedStyle(el, null).getPropertyValue('z-index')) || 0;
      // }));
      // console.log(maxIndex, 'confirmDialog el');
      // getComputedStyle的属性只读不可修改，需要修改内联样式
      // instance.$el.style.zIndex = String(maxIndex + 2);
      // console.log(document.defaultView.getComputedStyle(instance.$el, null).getPropertyValue('z-index'), 'confirmDialog el');
    })
  }
}

export default function (params) {
  currentMsg.message = params.message || '确认执行该操作吗？'
  currentMsg.title = params.title || '提醒'
  return new Promise((resolve, reject) => { // eslint-disable-line
    currentMsg.resolve = resolve
    currentMsg.reject = reject
    showMsg(params)
  })
}



// WEBPACK FOOTER //
// ./src/components/confirmDialog/main.js